import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app"
import { getAuth, type Auth } from "firebase/auth"
import { getStorage, type FirebaseStorage } from "firebase/storage"

/**
 * Web app config — set GATSBY_FIREBASE_* in `.env.development` / Vercel (see firebase.env.example).
 */
const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY || "AIzaSyAkoKVakoHS_z1N8tBQQRS2F-QFNz3EQvg",
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN || "photo-sharpener.firebaseapp.com",
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL || "https://photo-sharpener-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID || "photo-sharpener",
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET || "photo-sharpener.firebasestorage.app",
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID || "583641036035",
  appId: process.env.GATSBY_FIREBASE_APP_ID || "1:583641036035:web:7082bf76620bfccae5a536",
}

/** True when env vars are present (SSR-safe; avoids hydration mismatch). */
export function isFirebaseConfigured(): boolean {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.projectId)
}

export function getFirebaseApp(): FirebaseApp | null {
  if (typeof window === "undefined") return null
  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) return null
  if (getApps().length > 0) return getApp()
  return initializeApp(firebaseConfig)
}

export function getFirebaseAuth(): Auth | null {
  const app = getFirebaseApp()
  if (!app) return null
  return getAuth(app)
}

export function getFirebaseStorage(): FirebaseStorage | null {
  const app = getFirebaseApp()
  if (!app) return null
  return getStorage(app)
}
